import { createRootRouteWithContext } from '@tanstack/react-router'
//import { TanStackRouterDevtools } from '../TanStackRouterDevtools';
// import { Suspense } from 'react'
import App from '../App'
import { QueryClient } from '@tanstack/react-query'
import { type AuthState } from '@zendia/frontend-shared'

type RouteContext = {
  queryClient: QueryClient
  auth: AuthState
}

export const Route = createRootRouteWithContext<RouteContext>()({
  component: () => (
    <>
      <App />
      {/* <Suspense><TanStackRouterDevtools position="top-right" /></Suspense> */}
    </>
  ),
})
